import useVariantPickerQuickView from './useVariantPickerQuickView';

export default function useCloseVariantPickerQuickview() {
    const [, toggle] = useVariantPickerQuickView();

    return () => {
        toggle((prevValue) => ({
            isOpen: false,
            variantPickerModel: prevValue.variantPickerModel,
            isPDPRequest: prevValue.isPDPRequest
        }));
    };
}
